import type { BlocksTemplateUrlProps } from '../types/BlocksTemplateUrlProps';
import { getBlocksTemplateUrlParams } from './urlParams-utils';
import { baseUrl } from './consts';
import { APP_BASE_ROUTE, APP_PAGES } from '../constants/routes';

export const getBlocksTemplateUrl = (props: BlocksTemplateUrlProps) => {
  const queryParams = getBlocksTemplateUrlParams(props);
  return `${baseUrl}${APP_BASE_ROUTE}${APP_PAGES.OPEN_BLOCKS_TEMPLATE_ROUTE}?${queryParams}`;
};
